<template>
  <div class="hero-image position-relative">
    <img :src="image__sm" class="d-inline d-md-none img--center" :alt="alt" />
    <img
      :src="image"
      class="d-none d-md-inline"
      :class="right ? 'img--right' : 'img--center'"
      :alt="alt"
    />

    <div class="container h-100 position-relative">
      <b-row class="h-100">
        <b-col
          cols="12"
          v-if="isHome"
          class="is-home d-flex align-items-start align-items-md-end justify-content-start justify-content-md-start"
        >
          <div>
            <h1>
              <span v-if="pre" class="soft-text d-block pre-copy" v-html="pre"
                >pre</span
              >
              <span class="svg-container d-block">
                <img
                  :alt="alt"
                  src="@/assets/images/3_25/home/rise-and-shine.svg"
                />
              </span>
              <span class="accent-text d-block post-copy" v-html="post"
                >post</span
              >
            </h1>
            <p class="fw-bold" :class="{ 'd-none d-md-block': isParisCampaign }" v-html="copy"></p>
            <small v-if="!isParisCampaign" class="portrayal portrayal-mob fw-bold text-white"
              >Actor portrayal. Individual results may vary.</small
            >
          </div>
        </b-col>
        <b-col
          cols="12"
          md="7"
          v-else
          class="d-flex align-items-end justify-content-start justify-content-md-start"
        >
          <div>
            <h1 class="font-fields" v-html="title"></h1>
            <p
              v-if="subtitle"
              class="fw-bold hero__subtitle"
              v-html="subtitle"
            ></p>
            <small class="portrayal portrayal-mob fw-bold text-white"
              >Actor portrayal. Individual results may vary.</small
            >
          </div>
        </b-col>
      </b-row>

      <small
        v-if="!isHome || !isParisCampaign"
        class="portrayal portrayal-desk fw-bold text-white d-flex flex-column"
      >
        <span>
          Actor portrayal.
        </span>
        <span>Individual results may vary.</span>
      </small>
    </div>

    <!-- Paris Ambassador Purple Box Disclosure (Pre-Oct 1) -->
    <div
      v-if="isHome && isParisCampaign"
      class="purple-box position-absolute text-white fw-bold"
    >
      <p class="m-0">
        Paris Hilton is a JORNAY PM patient and compensated brand ambassador.
      </p>
      <p class="m-0">Individual results may vary.</p>
    </div>
    
    <!-- Paris Mobile Gradient Box (Pre-Oct 1) -->
    <div class="d-md-none d-block" v-if="isHome && isParisCampaign">
      <div class="gradiant-purple-box position-absolute text-white fw-bold d-flex align-items-end mb-0 justify-content-center">
        <p class="fw-bold mobile-p" v-html="copy"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    image__sm: String,
    timeStamp1: String,
    timeStamp2: String,
    title: String,
    titleImage: String,
    subtitle: String,
    alt: String,
    right: Boolean,
    margin: Boolean,
    noSubtitleMobile: Boolean,
    disclaimer: String,
    isHome: Boolean,
    isParisCampaign: Boolean,
    pre: String,
    post: String,
    copy: String,
  },
  data() {
    return {
      isShown: false,
    };
  },
  mounted() {
    setInterval(() => {
      this.isShown = !this.isShown;
    }, 1000);
  },
};
</script>
